import { render, staticRenderFns } from "./showImg3.vue?vue&type=template&id=09454437&scoped=true"
import script from "./showImg3.vue?vue&type=script&lang=js"
export * from "./showImg3.vue?vue&type=script&lang=js"
import style0 from "./showImg3.vue?vue&type=style&index=0&id=09454437&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09454437",
  null
  
)

export default component.exports